import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import PenIcon from "../icons/PenIcon";
import { useEnterprise } from "../../hooks/enterprises.hooks";
import EnterpriseForm, { EnterpriseFormHandler } from "../forms/EnterpriseForm";
import { useRef } from "react";
import PrimaryButton from "../PrimaryButton";
import { useMutation, useQueryClient } from "react-query";
import { updateEnterprise } from "../../mutations/enterprise.mutations";

type EnterpriseModalProps = {
	id?: number;
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
};

function EnterpriseModal({ id, isOpen, onClose }: EnterpriseModalProps) {
	const { data: entreprise, isLoading } = useEnterprise(id);
	const ref = useRef<EnterpriseFormHandler>(null);
	const queryClient = useQueryClient();
	const { mutate: mutateUpdateEnterprise } = useMutation(updateEnterprise, {
		onSuccess: () => {
			queryClient.invalidateQueries("enterprises");
			onClose();
		},
	});
	const handleSubmit = async () => {
		if (ref.current) {
			const valid = await ref.current.valid();
			if (valid) {
				const values = ref.current.values();
				mutateUpdateEnterprise({
					id: id,
					...values,
				});
			}
		}
	};

	if (isLoading) {
		return <></>;
	}
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<PenIcon w="24px" h="24px" color="brand.700"></PenIcon>
						</Flex>
						<Box lineHeight="48px">Editer les informations de l'entreprise</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					<EnterpriseForm
						ref={ref}
						value={entreprise ?? undefined}
					></EnterpriseForm>
				</ModalBody>
				<ModalFooter>
					<PrimaryButton onClick={handleSubmit}>Sauvegarder</PrimaryButton>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}

export default EnterpriseModal;
